module.exports = __webpack_public_path__ + "media/images/oak/slides/slide-1-full-3eee141ac8d2d7cd2626d054050652cf.jpg";